<template>
  <div>
      <span v-if="commentType !== 'record'"
            class="comment-author text-primary mr-2">
        {{ comment.author ? comment.author.full_name : '' }}
      </span>
    <span class="comment-date text-muted mr-2">
        {{ formatDateTime(commentType === 'record' ? comment.record.updated_at : comment.created_at) }}
      </span>
    <a class="mr-2 pointer"
       @click="emit('togglePin')"
       :title="comment.pinned ? $t('unpin') : $t('pin')"
       v-b-tooltip.hover>
      <PinSvg class="mb-1 svg-light"/>
      <span v-if="comment.pinned" class="ml-2 pinned d-inline-block">{{ $t('pinned') }}</span>
    </a>
    <a v-if="canBeEdited && !editMode"
       class="mr-2 pointer"
       @click="emit('editComment')">
      <EditSvg class="svg-stroke-light mb-1"/>
    </a>
    <a class="pointer"
       v-if="canBeDeleted"
       @click="emit('deleteComment')">
      <TrashSvg class="svg-stroke-light mb-1"/>
    </a>
  </div>
</template>

<script setup>
import PinSvg from "@/assets/svg-vue/patients/pin.svg.vue"
import EditSvg from "@/assets/svg-vue/general/edit2.svg.vue"
import TrashSvg from "@/assets/svg-vue/general/delete2.svg.vue"
import {formatDateTime} from "@/extensions/filters/filters"
import {computed} from "vue"
import {useStore} from "vuex"

const store = useStore()

const props = defineProps({
  comment: {},
  editMode: Boolean,
  canBeEdited: Boolean,
})

const emit = defineEmits(["editComment", 'deleteComment', 'togglePin'])

const commentType = computed(() => props.comment.comment_type)
const isAuthor = computed(() => store.state.auth.user.id === Number(props.comment.created_by))
const canBeDeleted = computed(() => isAuthor.value && commentType.value === 'manual')
</script>
